import LicenseRouter from './LicenseRouter'
export default LicenseRouter
